import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIClaimDataTypeGetList } from './ClaimDataTypes.api';

export const fetchClaimDataTypes = createAsyncThunk('claimDataTypes/fetchClaimDataTypes', async () => {
    const response = await APIClaimDataTypeGetList();
    return response.data;
});
